import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CourseService {

  apiUrl = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  addFileName(fileName: any): Observable<any> {
    return this.http.post<any>(this.apiUrl + "successfactors/add", fileName);
  }

  getCourseMapping(pageNumber: any): Observable<any> {
    return this.http.get(this.apiUrl + '/course/mapping/' + pageNumber);
  }

  addCourseName(newCourseAssessment: any, autoCourseCompletion: any): Observable<any> {
    return this.http.post<any>(this.apiUrl + "assessment/new/" + newCourseAssessment + '/' + autoCourseCompletion, {}, { responseType: 'text' as 'json' });
  }

  getAssessmentName(): Observable<any> {
    return this.http.get(this.apiUrl + '/assessment/name');
  }

  getAssessmentId(assessmentNameId: any): Observable<any> {
    return this.http.get(this.apiUrl + '/assessment/test/' + assessmentNameId);
  }

  getTopicId(testId: any): Observable<any> {
    return this.http.get(this.apiUrl + '/assessment/topic/' + testId);
  }

  addAssessement(addAssessementObj: any): Observable<any> {
    return this.http.post<any>(this.apiUrl + "/assessment/add", addAssessementObj, { responseType: 'text' as 'json' });
  }

  getSuccessFactor() {
    return this.http.get(this.apiUrl + '/successfactors/getSuccessFactor');
  }

  getReportData(id: any, pageNumber: any) {
    return this.http.get(this.apiUrl + '/successfactors/getReportData/' + id + '/' + pageNumber);
  }

  deleteTopicCourse(postObj: any): Observable<any> {
    return this.http.delete<any>(this.apiUrl + "/course/courseDelete", { body: postObj, responseType: 'text' as 'json' });
  }
}